import * as React from 'react';

import { Button } from '@coursera/cds-core';
import { useVisibilityTracker } from '@coursera/event-pulse/react';

import type { AutocompleteMode } from 'bundles/search-common/constants/autocomplete';
import { type AutocompleteItems, getAutocompleteEventingData } from 'bundles/search-common/utils/autocomplete';

type Props = {
  autocompleteState: AutocompleteMode;
  id: string;
  recentlyViewedItems: AutocompleteItems;
  suggestionIndex: number;
  children: React.ReactNode;
  groupId?: string;
};

const AutocompleteTrendingOption = ({
  autocompleteState,
  id,
  recentlyViewedItems,
  suggestionIndex,
  children,
  groupId,
}: Props) => {
  const trackingData = getAutocompleteEventingData(id, autocompleteState, recentlyViewedItems, suggestionIndex);
  const trackingRef: React.MutableRefObject<HTMLDivElement | null> = useVisibilityTracker(
    'view_autocomplete_suggestions',
    trackingData,
    [],
    { fullyVisible: true, initialDelay: 1000 }
  );

  return (
    <div ref={trackingRef} data-group={groupId}>
      <Button variant="secondary" size="small">
        {children}
      </Button>
    </div>
  );
};

export default AutocompleteTrendingOption;
